import { cn } from '@commenda/utils';
import { Icons } from '../Icons';

interface IInputErrorMessage extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
}

const InputErrorMessage = ({ className, message }: IInputErrorMessage) => {
  return (
    <div className={cn('flex gap-1 items-start', className)}>
      <Icons.AlertCircle className="text-text-error h-4" />
      <span className="txt-small-regular text-text-error -mt-0.5">
        {message}
      </span>
    </div>
  );
};

export { InputErrorMessage };
